import * as React from 'react';
import { Link } from 'react-router-dom';
import { reaction } from 'mobx';
import { inject } from 'mobx-react';
import { ClickTracker } from 'bernie-analytics';
import { EGDSTertiaryButton } from '@egds/react-core/button';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSText } from '@egds/react-core/text';
import { LocalizedText } from '@shared-ui/localization-context';
import { ChangeSearchForm } from './change-search-form';
import { CloseFormButton } from './close-form-button';
import { CollapsedSearchPlayback } from './collapsed-search-playback';
const LinkTracked = ClickTracker(Link);
export const CollapsibleSearchForm = inject('analytics', 'searchResults', 'uiPage')(({
  analytics,
  uiPage,
  searchResults
}) => {
  const buttonRef = React.useRef();
  const [expanded, setExpanded] = React.useState(searchResults === null || searchResults === void 0 ? void 0 : searchResults.expandForm);
  const [jsEnabled, setJsEnabled] = React.useState(false);
  const handleExpand = () => setExpanded(!expanded);
  React.useEffect(() => {
    setJsEnabled(true);
    const disposerUiPageOpenDatePickerEvent = reaction(() => uiPage === null || uiPage === void 0 ? void 0 : uiPage.openNewDatePickerEvent, openNewDatePickerEvent => {
      if (openNewDatePickerEvent) {
        setExpanded(true);
      }
    });
    return () => {
      disposerUiPageOpenDatePickerEvent();
      searchResults === null || searchResults === void 0 ? void 0 : searchResults.setExpandForm(false);
    };
  }, [searchResults, uiPage === null || uiPage === void 0 ? void 0 : uiPage.openNewDatePickerEvent]);
  React.useEffect(() => {
    if (!expanded && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
    analytics === null || analytics === void 0 ? void 0 : analytics.trackEvent(`:${expanded ? 'ChangeSearch' : 'CloseForm'}`, 'Edit search form', null);
  }, [expanded, buttonRef]);
  return React.createElement("div", {
    "data-stid": "collapsible-playback"
  }, !expanded && React.createElement("h2", {
    className: "is-visually-hidden"
  }, React.createElement(LocalizedText, {
    message: "hotels.infosite.availabilityWizard.changeSearch.a11yLabel"
  })), jsEnabled ? React.createElement(React.Fragment, null, React.createElement(ChangeSearchForm, {
    isHidden: !expanded
  }), !expanded && React.createElement(EGDSTertiaryButton, {
    "data-stid": "form_expander",
    isFullWidth: true,
    onClick: handleExpand,
    domRef: buttonRef
  }, React.createElement(EGDSText, {
    overflow: "truncate"
  }, React.createElement(EGDSLayoutFlex, null, React.createElement(EGDSLayoutFlexItem, {
    minWidth: "full_width"
  }, React.createElement(CollapsedSearchPlayback, null)))))) : React.createElement(LinkTracked, {
    "data-stid": "playback-action",
    linkName: "Edit search form",
    rfrr: ":ChangeSearch",
    to: "/Hotels"
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'one'
    },
    padding: {
      inline: 'three'
    }
  }, React.createElement(CollapsedSearchPlayback, null))), expanded && React.createElement(CloseFormButton, {
    onClick: handleExpand
  }));
});